// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-input-root.error > label, .w-input-root.error > label.fill.fancy { color: #de4b52;\n}\n.w-input-root.error > .w-input {\n\tbackground-color: #fdedee;\n\tborder: 1px solid #f8a9ad;\n\tcolor: #de4b52;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
